import { render } from "./TechnologiesSection.vue?vue&type=template&id=82f6d2e2&scoped=true"
import script from "./TechnologiesSection.vue?vue&type=script&lang=js"
export * from "./TechnologiesSection.vue?vue&type=script&lang=js"

import "./TechnologiesSection.vue?vue&type=style&index=0&id=82f6d2e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f6d2e2"]])

export default __exports__